export default "__VITE_ASSET__C8WiNgzZ__"